import { IPromise } from 'angular'
import { VdTracking } from '@vend/vend.js'

/**
 * Controller class for adding a note before parking a sale.
 */
export class ActionAddNoteParkSaleController {
  public note: string
  public isParkSale: boolean
  public isReturn: boolean
  public isAccountBalancePaymentAdded: boolean

  constructor(
    private readonly close: (v: any) => IPromise<any>,
    options: {
      currentNote: string
      isParkSale: boolean
      isReturn: boolean
      isAccountBalancePaymentAdded: boolean
    },
    private readonly vdTracking: VdTracking
  ) {
    'ngInject'
    this.note = options.currentNote
    this.isParkSale = options.isParkSale
    this.isReturn = options.isReturn
    this.isAccountBalancePaymentAdded = options.isAccountBalancePaymentAdded
  }

  /**
   * Close the modal, resolve with the updated note.
   */
  public addNoteAndParkSale(isQuote: boolean) {
    if (isQuote) {
      this.vdTracking.trackUserEvent({
        eventName: 'Quote Clicked',
        metadata: {
          has_note: Boolean(this.note),
        },
      })
    }
    this.close({ note: this.note, isQuote })
  }
}
